// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "wrapper-11PzX";
var _5 = "baggageBanner-Yq72K";
var _6 = "text-NgfmA";
var _7 = "image-1QRxB";
var _8 = "disclaimer-oUPNP";
var _9 = "additional-324IV";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "wrapper", _5 as "baggageBanner", _6 as "text", _7 as "image", _8 as "disclaimer", _9 as "additional" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "wrapper": _4, "baggageBanner": _5, "text": _6, "image": _7, "disclaimer": _8, "additional": _9 }
